import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TableConfig } from '@angular-generic-table/core/lib/models/table-config.interface';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { map, pluck, switchMap, takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalActionService } from '../../../features/modal/services/modal-action.service';
import { InstrumentsQuery } from '../../state/instruments/instruments.query';
import { UserSettingsQuery } from '../../../features/user-settings/state/user-settings.query';

@Component({
    selector: 'app-sb-history',
    templateUrl: './sb-history.component.html',
    styles: []
})
export class SbHistoryComponent implements OnInit {
    unsubscribe$ = new Subject();
    constructor(
        private route: ActivatedRoute,
        private injector: Injector,
        private _userSettingsQuery: UserSettingsQuery,
        private modalActionService: ModalActionService,
        private instrumentsQuery: InstrumentsQuery,
        private router: Router
    ) {
        this.modalActionService
            .onAction$('addData')
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((_) => {
                this.router.navigate(
                    [
                        '',
                        {
                            outlets: {
                                dialog: [
                                    'action',
                                    'commercial-real-estate',
                                    'add',
                                    this.route.snapshot.params.id
                                ]
                            }
                        }
                    ],
                    {
                        queryParams: {
                            type: this.instrumentsQuery.getInstrumentById(
                                this.route.snapshot.params.id
                            )?.instrumentData
                        }
                    }
                );
            });
    }
    @ViewChild('formattedAmount', { static: true }) formattedAmount:
        | TemplateRef<any>
        | undefined;
    @ViewChild('formattedNumber', { static: true }) formattedNumber:
        | TemplateRef<any>
        | undefined;
    @ViewChild('formattedPercent', { static: true }) formattedPercent:
        | TemplateRef<any>
        | undefined;
    periods: Array<any> = [
        {
            name: 'Month',
            format: 'MMM yy'
        },
        {
            name: 'Quarter',
            format: 'QQQ yy'
        },
        {
            name: 'Year',
            format: 'yyyy'
        }
    ];
    period$ = new BehaviorSubject({
        ...this.periods[2]
    });
    loading$ = new BehaviorSubject(false);

    data$: Observable<any> = combineLatest([
        this.route.data.pipe(map((data) => this.injector.get(data.queryService))),
        this.route.params.pipe(
            pluck('id'),
            map((stringId) => +stringId)
        ),
        this.period$
    ]).pipe(
        switchMap(
            ([query, id, period]) =>
                query.getHistoryForPeriodById$(id, period.format) as Observable<any>
        )
    );
    config: TableConfig = {};

    tableConfig$: Observable<TableConfig> = this._userSettingsQuery
        .selectGlobalSetting$('LOCALE')
        .pipe(
            map(
                (locale): TableConfig => ({
                    stickyHeaders: {
                        row: true
                    },
                    rows: {
                        period: {
                            class: 'text-right',
                            header: false
                        },
                        totalArea: {
                            class: 'text-right',
                            templateRef: this.formattedNumber
                        },
                        totalEconomicArea: {
                            header: 'Total Economic Area',
                            class: 'text-right',
                            templateRef: this.formattedNumber
                        },
                        occupiedArea: {
                            class: 'text-right',
                            templateRef: this.formattedNumber
                        },
                        economicOccupancyRate: {
                            header: 'Economic Occupancy Rate %',
                            class: 'text-right',
                            templateRef: this.formattedPercent
                        },
                        investments: {
                            class: 'text-right',
                            templateRef: this.formattedAmount
                        },
                        value: {
                            class: 'text-right',
                            templateRef: this.formattedAmount
                        },
                        /*loan: {
                        class: 'text-right',
                        templateRef: this.formattedAmount
                    },
                    amortization: {
                        class: 'text-right',
                        templateRef: this.formattedAmount
                    },*/
                        loanMinusAmortization: {
                            header: 'Loan',
                            class: 'text-right',
                            templateRef: this.formattedAmount
                        },
                        cost: {
                            class: 'text-right',
                            templateRef: this.formattedAmount
                        },
                        income: {
                            class: 'text-right',
                            templateRef: this.formattedAmount
                        },
                        noi: {
                            header: 'NOI',
                            class: 'text-right',
                            templateRef: this.formattedAmount
                        },
                        ltv: {
                            header: 'LTV',
                            class: 'text-right',
                            templateRef: this.formattedPercent
                        },
                        yield: {
                            header: 'Yield %',
                            class: 'text-right',
                            templateRef: this.formattedPercent
                        },
                        moic: {
                            header: 'MOIC',
                            class: 'text-right',
                            templateRef: this.formattedNumber
                        },
                        valuePerUnitOfArea: {
                            header: 'Value per SQM',
                            class: 'text-right',
                            templateRef: this.formattedNumber
                        }
                    }
                })
            )
        );

    ngOnInit(): void {}

    setPeriod(period: any) {
        this.period$.next({ ...period });
    }
}
